import React from 'react';
import { useHistory } from 'react-router-dom';
import { HeroIconCheveronLeft } from 'toolbox';

interface GoBackButtonProps {}

export const GoBackButton: React.FC<GoBackButtonProps> = ({ children }) => {
  const history = useHistory();
  return (
    <button
      onClick={() => history.goBack()}
      className="flex items-center pr-2 text-sm font-semibold tracking-tight text-gray-600 bg-gray-400 rounded focus:bg-jcap-700 focus:text-jcap-100 focus:outline-none"
    >
      <HeroIconCheveronLeft />
      {children}
    </button>
  );
};

export default GoBackButton;
